<template>
  <!-- 货物维护 -->
  <div class="containerbox serverContent">
    <!-- 按钮列表 -->
    <div class="glo_btnList" ref="btnList">
      <div class="glo_btnList_left">
        <el-button class="itemBtn btnColor glo_bgcMainColor" @click="addServe()"
          >新建</el-button
        >
        <el-button class="itemBtn btnColor" @click="DelServe()"
          >批量删除</el-button
        >
        <el-dropdown class="topDropDown" @command="topCommandBtns">
          <el-button type="primary">
            更多操作<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="dc">导出</el-dropdown-item>
            <el-dropdown-item command="bgsz">表格设置</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <queryBtns
        :MoreConditions="MoreConditions"
        :showMoreBtns="false"
        @clerBtns="clerBtns"
        @queryBtn_ok="queryBtn_ok"
        @moreParam="moreParam"
      ></queryBtns>
    </div>
    <!-- 查询条件 -->
    <div ref="queryForm">
      <el-form
        :model="queryData"
        :class="isHaseMore ? 'glo_form hasMoreParam' : 'glo_form'"
        label-position="left"
      >
        <el-form-item class="queryItems" label="渠道物品名称:">
          <el-select
            filterable
            clearable
            v-model="queryData.itemNameCode"
            placeholder="请选择"
            @change="changeItemName"
          >
            <el-option
              v-for="(item, index) in ItemNameList"
              :key="index"
              :label="item.itemCategoryName"
              :value="item.itemCategoryCode"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="queryItems" label="助记码:">
          <el-input
            clearable
            v-model="queryData.mnemonicCode"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>

    <!-- 表格:height="tableHeigth" -->
    <div class="glo_Table" ref="tableWrapper">
      <el-table
        ref="mytable"
        :data="tableData"
        :height="tableHeigth"
        :row-class-name="tableRowClassName"
        highlight-current-row
        @row-click="rowclick"
        :header-cell-style="{ background: '#f0f0f0' }"
        border
        @selection-change="handleSelectionChange"
      >
        <el-table-column fixed="left" label="序号" type="index" width="60">
        </el-table-column>
        <el-table-column fixed="left" type="selection" width="60">
        </el-table-column>

        <template v-for="(item, index) in myTableHeard">
          <el-table-column
            v-if="item.field == 'isShowShow'"
            :key="index"
            :label="item.name"
            sortable
            :min-width="item.width"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.isShowShow == '禁用'" style="color: #f00">
                {{ scope.row.isShowShow }}
              </div>
              <div v-else>{{ scope.row.isShowShow }}</div>
            </template>
          </el-table-column>
          <el-table-column
            v-else-if="item && item.isShow"
            :key="index"
            :label="item.name"
            :prop="item.field"
            sortable
            :min-width="item.width"
            :data-isTotal="item.isTotal"
          >
          </el-table-column>
        </template>
        <el-table-column fixed="right" label="操作" min-width="120px">
          <template slot-scope="scope">
            <div class="tabRightBtns">
              <el-button class="rbtns" @click.stop="editorServe(scope.row)"
                >编辑</el-button
              >

              <el-button class="rbtns" @click.stop="DelServe(scope.row.itemId)"
                >删除</el-button
              >
              <!-- 如果按钮超过4个就要用下面这种下拉的样式 -->
              <!-- <el-dropdown
                class="rbtns"
                @command="handleCommandBtns($event, scope.row)"
              >
                <el-button type="primary">
                  更多操作<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="a">修改密码</el-dropdown-item>
                  <el-dropdown-item command="b">删除</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown> -->
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页组件 -->
    <paging
      ref="pags"
      :pageNum="pageStart"
      :total="pageCount"
      :size="pageTotal"
      class="serverPage"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    ></paging>

    <!-- 新建弹窗 -->
    <myDialog
      :diaWidth="diaWidth"
      :dialogTitle="dialogTitle"
      :isShowDialog="isShowDialog"
      @handleCloseDia="handleCloseDia"
      @diaCancelBtn="handleCloseDia"
      @diaConfirmBtn="diaConfirmBtn('dialogFormRef')"
    >
      <div class="glo_dialogForm">
        <el-form
          v-if="isShowDialog"
          class="diaForm"
          ref="dialogFormRef"
          :model="dialogForm"
          label-width="110px"
          :rules="rulesForm"
        >
          <el-form-item
            class="dialogFormItems"
            prop="customerName"
            label="厂家(客户):"
          >
            <el-select
              clearable
              filterable
              remote
              :remote-method="getCustomerList"
              default-first-option
              v-model="dialogForm.customerName"
              placeholder="请选择"
              @change="changeCustomer"
            >
              <el-option
                v-for="(item, index) in CustomerLists"
                :key="index"
                :label="item.name"
                :value="item.name"
              ></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item class="dialogFormItems" prop="aaa" label="客户编号:">
            <el-input
              disabled
              v-model="dialogForm.aaa"
              placeholder="自动获取"
            ></el-input>
          </el-form-item> -->
          <el-form-item
            class="dialogFormItems"
            prop="itemName"
            label="货物名称:"
          >
            <el-input
              v-model="dialogForm.itemName"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item
            class="dialogFormItems"
            prop="itemNameCode"
            label="货物编码:"
          >
            <el-input
              v-model="dialogForm.itemNameCode"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item
            class="dialogFormItems"
            prop="itemCategoryCode"
            label="品类:"
          >
            <el-select
              filterable
              clearable
              v-model="dialogForm.itemCategoryCode"
              placeholder="请选择"
              @change="changeItemName2"
            >
              <el-option
                v-for="(item, index) in ItemNameList"
                :key="index"
                :label="item.itemCategoryName"
                :value="item.itemCategoryCode"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item class="dialogFormItems" prop="sku" label="SKU:">
            <el-input v-model="dialogForm.sku" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item
            class="dialogFormItems"
            prop="mnemonicCode"
            label="助记码:"
          >
            <el-input
              v-model="dialogForm.mnemonicCode"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item
            class="dialogFormItems"
            prop="specsModel"
            label="规格型号:"
          >
            <el-input
              v-model="dialogForm.specsModel"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="unitPrice" label="单价:">
            <el-input
              v-model="dialogForm.unitPrice"
              type="number"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item
            class="dialogFormItems"
            prop="unitConfDictId"
            label="单位:"
          >
            <el-select
              filterable
              clearable
              v-model="dialogForm.unitConfDictId"
              placeholder="请选择"
            >
              <el-option
                v-for="(item, index) in unitLists"
                :key="index"
                :label="item.key"
                :value="item.confDictId"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item
            class="dialogFormItems"
            prop="oneCount"
            label="单件数量:"
          >
            <el-input
              v-model="dialogForm.oneCount"
              type="number"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item
            class="dialogFormItems"
            prop="oneWeight"
            label="单件重量(KG):"
          >
            <el-input
              v-model="dialogForm.oneWeight"
              type="number"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item
            class="dialogFormItems"
            prop="oneVolume"
            label="单件体积(m³):"
          >
            <el-input
              v-model="dialogForm.oneVolume"
              type="number"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item
            class="dialogFormItems"
            prop="packageCount"
            label="包装数量:"
          >
            <el-input
              v-model="dialogForm.packageCount"
              type="number"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item
            class="dialogFormItems"
            prop="packageVolume"
            label="包装体积(m³):"
          >
            <el-input
              v-model="dialogForm.packageVolume"
              type="number"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item
            class="dialogFormItems"
            prop="packageWeight"
            label="包装重量(KG):"
          >
            <el-input
              v-model="dialogForm.packageWeight"
              type="number"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item
            class="dialogFormItems"
            prop="packageLength"
            label="包装长度(cm):"
          >
            <el-input
              v-model="dialogForm.packageLength"
              type="number"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item
            class="dialogFormItems"
            prop="packageWidth"
            label="包装宽度(cm):"
          >
            <el-input
              v-model="dialogForm.packageWidth"
              type="number"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item
            class="dialogFormItems"
            prop="packageHeigt"
            label="包装高度(cm):"
          >
            <el-input
              v-model="dialogForm.packageHeigt"
              type="number"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="sort" label="排序:">
            <el-input
              v-model="dialogForm.sort"
              type="number"
              placeholder="请输入"
            ></el-input>
          </el-form-item>

          <el-form-item class="dislogFormTextarea" prop="comment" label="备注:">
            <el-input
              type="textarea"
              rows="2"
              v-model="dialogForm.comment"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
    </myDialog>

    <!-- 修改密码 -->
    <myDialog
      :diaWidth="diaWidth2"
      :dialogTitle="dialogTitle2"
      :isShowDialog="isShowDialog2"
      @handleCloseDia="handleCloseDia2"
      @diaCancelBtn="diaCancelBtn2"
      @diaConfirmBtn="diaConfirmBtn2"
    >
      <div class="glo_dialogForm">
        <el-form
          class="diaForm"
          ref="dialogForm2"
          :model="dialogForm2"
          label-width="100px"
          :rules="rulesForm2"
        >
          <el-form-item
            class="dialogFormItems"
            style="margin: 70px auto"
            prop="aaa"
            label="新密码:"
          >
            <el-input v-model="dialogForm.aaa" placeholder="请输入"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </myDialog>

    <!--        自定义表头           -->
    <sorttable
      :show_sortTableHeard="show_sortTableHeard"
      :allCheck="allCheck"
      :sortName="sortName"
      :tabelHeadeTitle="tabelHeadeTitle"
      :originalTabelHeadeTitle="originalTabelHeadeTitle"
      :selectLength="selectLength"
      @cancelSortHeard="cancelSortHeard"
      @confirmOk="confirmOk"
      @checktab="checktab"
      @checkAll="checkAll"
      @closeDias="closeDias"
    >
    </sorttable>
  </div>
</template>

<script>
// import { apiList, this.$API } from "@/assets/js/api";
// import tools from "@/assets/js/tool";
import paging from "@/components/pagings.vue";
import myDialog from "@/components/Dialog.vue";
import queryBtns from "@/components/queryBtns.vue";
import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
export default {
  inject: ["reload"],
  components: {
    queryBtns,
    myDialog,
    paging,
    sorttable,
  },
  data() {
    return {
      pageStart: 1, //页码
      pageTotal: this.$COMMON.pageTotals, //一页几条,
      pageCount: 0, //总条数
      tableHeigth: "75vh",
      selectTableData: [],

      queryData: { itemName: "", itemNameCode: "", mnemonicCode: "" },
      MoreConditions: "更多条件", //  输入框绑定动态class
      isHaseMore: false, //false == 更多条件  true ==收起条件

      // ==== 弹窗组件属性 start ====
      isShowDialog: false,
      dialogTitle: "",
      dialogType: "add",
      diaWidth: "60%",
      dialogForm: {
        // 弹窗表单数据
        customerName: "",
        customerNumber: "",
        itemName: "",
        itemNameCode: "",
        comment: "",
        itemCategoryCode: "",
        itemCategoryName: "",
        mnemonicCode: "",
        oneCount: "1",
        oneVolume: "",
        oneWeight: "",
        packageCount: "1",
        packageHeigt: "",
        packageLength: "",
        packageVolume: "",
        packageWidth: "",
        sku: "",
        sort: "1",
        specsModel: "",
        unitConfDictId: "",
        unitPrice: "",
      },
      rulesForm: {
        customerName: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        customerNumber: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
        itemName: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
        itemNameCode: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
      },

      isShowDialog2: false,
      dialogTitle2: "修改密码",
      diaWidth2: "30%",
      dialogForm2: {
        // 弹窗表单数据
        aaa: "",
        bbb: "",
        ccc: "",
      },
      rulesForm2: {
        aaa: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
      },

      // upLoadUrl: this.$COMMON.uploadUrl,
      fileNameLists: [],
      pageType: "add",

      className: "",
      ItemNameList: [],
      myTableHeard: [], //我的表头
      originalTabelHeadeTitle: [],
      selectLength: 0, //显示的长度
      allCheck: false, //全选
      leftHeight: "75vh",
      tableHeigth: "75vh",
      tabelHeadeTitle: [
        {
          name: "厂家(客户)",
          field: "customerName",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
          width: "120",
        },
        {
          name: "客户编号",
          field: "customerNumber",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
          width: "120",
        },
        {
          name: "货物编码",
          field: "itemNameCode",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
          width: "120",
        },
        {
          name: "SKU",
          field: "sku",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
          width: "120",
        },
        {
          name: "货物名称",
          field: "itemName",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
          width: "120",
        },
        {
          name: "品类",
          field: "itemCategoryName",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
          width: "120",
        },
        {
          name: "规格型号",
          field: "specsModel",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
          width: "120",
        },
        {
          name: "助记码",
          field: "mnemonicCode",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
          width: "120",
        },
        {
          name: "单价",
          field: "unitPrice",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
          width: "120",
        },
        {
          name: "单位",
          field: "unitConfDictVal",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
          width: "120",
        },
        {
          name: "单件数量",
          field: "oneCount",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
          width: "120",
        },
        {
          name: "单件重量",
          field: "oneWeight",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
          width: "120",
        },
        {
          name: "单件体积",
          field: "oneVolume",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
          width: "120",
        },
        {
          name: "包装数量",
          field: "packageCount",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
          width: "120",
        },
        {
          name: "包装重量",
          field: "packageWeight",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
          width: "120",
        },
        {
          name: "包装体积",
          field: "packageVolume",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
          width: "120",
        },
        {
          name: "包装长度",
          field: "packageLength",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
          width: "120",
        },
        {
          name: "包装宽度",
          field: "packageWidth",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
          width: "120",
        },
        {
          name: "包装高度",
          field: "packageHeigt",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
          width: "120",
        },
        {
          name: "备注",
          field: "comment",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
          width: "120",
        },
      ],
      tableData: [],

      show_sortTableHeard: false, //显示表格设置弹窗
      originalTabelHeadeTitle: [], //自定义排序表头(恢复默认用)
      allCheck: false, //  全选
      sortName: "货物维护", //  排序名
      selectLength: 0, //  显示的长度
      totalArr: [], //  表格需要合计的字段
      className: "", //  导出需要
      pageGroupName: "CargoMaintenance", //  页面标识

      CustomerLists: [],
      unitLists: [],
    };
  },
  updated() {
    if (this.show_sortTableHeard) {
      // 排序表头
      let arr = this.tabelHeadeTitle;
      for (var i = 0; i < arr.length; i++) {
        arr[i].sort = i + 1;
      }
      this.tabelHeadeTitle = arr;
    }
  },
  created() {
    this.myTableHeard = this.tabelHeadeTitle;
    if (this.originalTabelHeadeTitle.length === 0) {
      this.originalTabelHeadeTitle = JSON.parse(
        JSON.stringify(this.tabelHeadeTitle)
      );
    }

    this.getData();
    //获取默认表头 页面有这四个字段 myTableHeard,sortName,tabelHeadeTitle,totalArr
    this.$TOOLS.getGroupFindFieldSort(this, this.pageGroupName);
    this.wtl_getCategoryList();
  },
  mounted() {},
  activated() {},
  watch: {},
  methods: {
    // 根据字典类型获取字典值下拉列表
    getConfDictValDownList(dictType) {
      this.$API
        .wtl_getConfDictValDownList({ dictType: dictType })
        .then((res) => {
          let arrs = res.data.result || [];
          if (dictType == "unit") {
            // 获取单位列表
            this.unitLists = arrs;
          }
        });
    },

    // 获取客户列表
    getCustomerList(name) {
      this.$API
        .wtl_getObjectUserDownList({
          key: "customer",
          name: name || "",
          pageStart: 1,
          pageTotal: 200,
        })
        .then((res) => {
          this.CustomerLists = res.data.result.data || [];
        });
    },
    // 选择或者清除客户时触发
    changeCustomer(e) {
      if (!e) {
        this.getCustomerList();
      } else {
        //
        this.CustomerLists.forEach((item) => {
          if (item.name == e) {
            this.dialogForm.customerNumber = item.number;
          }
        });
      }
    },
    // 选择物品名称
    changeItemName(e) {
      if (e) {
        this.ItemNameList.forEach((item) => {
          if (item.itemNameCode == e) {
            this.queryData.itemName = item.itemCategoryName;
          }
        });
      } else {
        this.wtl_getCategoryList();
      }

      this.queryBtn_ok();
    },
    // 选择物品名称
    changeItemName2(e) {
      if (e) {
        this.ItemNameList.forEach((item) => {
          if (item.itemNameCode == e) {
            this.dialogForm.itemCategoryName = item.itemCategoryName;
          }
        });
      } else {
        this.wtl_getCategoryList();
      }

      this.queryBtn_ok();
    },
    // 获取物品品类
    wtl_getCategoryList(categoryName) {
      this.$API
        .wtl_getCategoryList({
          categoryName: categoryName,
          pageStart: 1,
          pageTotal: 200,
        })
        .then((res) => {
          this.ItemNameList = res.data.result.data || [];
        });
    },
    //点击更多操作下的按钮
    handleCommandBtns(type, val) {
      // a==修改密码
      if (type === "a") {
        this.isShowDialog2 = true;
      }
      // d==删除
      if (type === "d") {
      }
    },

    //顶部跟多按钮的操作
    topCommandBtns(a) {
      if (a === "bgsz") {
        // 设置模板按钮
        // this.myModel();
        this.$TOOLS.myModel(this);
      }
      if (a === "dyyd") {
        // 打印运单
      }
      if (a === "dybq") {
        // 打印标签
      }
      if (a === "dr") {
        // 导入
      }
      if (a === "dc") {
        // 导出
        this.exportBtn();
      }
    },
    // 点击导出 (页面标识,表头,列表标识,数据源,表名)
    exportBtn() {
      this.$COMAPI.exportBtn({
        pageGroupName: this.pageGroupName, //页面标识
        myTableHeard: this.myTableHeard, //表头数组
        className: this.className, //列表标识
        tableData: this.tableData, //数据源
        sheetName: "表名(暂无效)", //表名
      });
    },
    queryBtn_ok() {
      //  查询按钮
      this.pageStart = 1;
      this.getData();
    },

    clerBtns() {
      //  重置按钮
      this.queryData = {};
    },

    moreParam() {
      this.isHaseMore = !this.isHaseMore;
      if (this.isHaseMore) {
        this.MoreConditions = "收起条件";
      } else {
        this.MoreConditions = "更多条件";
      }

      this.$nextTick(() => {
        this.fetTableHeight();
      });
    },

    rowclick(row, event, column) {
      this.$refs.mytable.toggleRowSelection(row);
    },

    // 删除
    DelServe(id) {
      let ids = [];
      if (id) {
        ids = [id];
      } else {
        if (this.selectTableData.length < 1) {
          this.$message.warning("请选择需要删除的数据");
          return false;
        }
        this.selectTableData.forEach((item) => {
          ids.push(item.itemId);
        });
      }

      this.$confirm("该操作将删除该货物,请谨慎操作!", "提示:")
        .then((res) => {
          let param = {
            itemIds: ids,
          };
          this.$API.wtl_delItem(param).then((res) => {
            this.$message.success(res.data.message || "操作成功");
            this.getData();
          });
        })
        .catch(() => {});
    },
    aaaaaa() {},
    // 分配权限
    AssignMent() {
      this.$router.push({
        path: "/SystemSetting/PermissionAssignmentUser",
        query: {},
      });
    },
    // 新建版本
    addServe() {
      this.isShowDialog = true;
      this.dialogTitle = "新建货物";
      this.dialogType = "add";

      this.getCustomerList(); //客户列表
      this.getConfDictValDownList("unit"); //获取单位列表
    },
    // 编辑
    editorServe(data) {
      this.isShowDialog = true;
      this.dialogTitle = "编辑货物";
      this.dialogType = "edit";
      console.log(data);
      this.dialogForm = data;

      this.getCustomerList(); //客户列表
      this.getConfDictValDownList("unit"); //获取单位列表
    },

    // 选择图片
    changeFileList(array) {
      this.fileNameLists = array;
    },

    //=>选择表格操作
    handleSelectionChange(e) {
      this.selectTableData = e;
    },
    //表格样式i
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return "warning-row";
      }
    },
    /**
     * ******************************计算表格高度**开始*************************
     */
    fetTableHeight() {
      // 重置table高度
      this.tabelHeigth = 0;
      // 设置table高度
      let windonHeight =
        document.body.clientHeight || document.documentElement.clientHeight; //页面高度
      let queryHeigth = 40 + 10; //10==margin-top: 10  查询框高度
      let btnListHeight = this.$refs.btnList.offsetHeight; // 按钮列表高度
      if (this.isHaseMore) {
        queryHeigth = this.$refs.queryForm.offsetHeight + 10; //查询框
      }
      let pagsHeigth = 40 + 20; //分页组件高度 20是上下margin
      var otherHeight = queryHeigth + btnListHeight + pagsHeigth + 60; //60是顶部导航 10是
      let tabHeight = Math.floor(windonHeight - otherHeight) || ""; //

      this.$nextTick(() => {
        this.tableHeigth = tabHeight;
        this.$refs.mytable.doLayout();
      });
    },
    /**
     * ******************************计算表格高度**结束*************************
     */

    //分页
    handleSizeChange(val) {
      this.pageTotal = val;
      this.getData();
    },
    handleCurrentChange(val) {
      this.pageStart = val;
      this.getData();
    },
    // 获取数据
    getData() {
      let that = this;
      let param = {
        itemName: this.queryData.itemName,
        itemNameCode: this.queryData.itemNameCode,
        mnemonicCode: this.queryData.mnemonicCode,
        pageStart: this.pageStart,
        pageTotal: this.pageTotal,
      };
      this.$API.wtl_getItemList(param).then((res) => {
        that.tableData = res.data.result.data || [];
        that.pageCount = res.data.result.pageCount || 0;
        that.className = res.data.result.className || 0;
        this.$nextTick(() => {
          this.fetTableHeight();
        });
      });
    },
    /***
     * ====== 弹窗组件方法 ======
     */
    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia() {
      this.isShowDialog = false;
      this.dialogForm = {
        customerName: "",
        customerNumber: "",
        itemName: "",
        itemNameCode: "",
        comment: "",
        itemCategoryCode: "",
        itemCategoryName: "",
        mnemonicCode: "",
        oneCount: "1",
        oneVolume: "",
        oneWeight: "",
        packageCount: "1",
        packageHeigt: "",
        packageLength: "",
        packageVolume: "",
        packageWidth: "",
        sku: "",
        sort: "1",
        specsModel: "",
        unitConfDictId: "",
        unitPrice: "",
      };
    },
    //  弹窗确认保存事件
    diaConfirmBtn(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.dialogForm.oneCount = this.dialogForm.oneCount * 1 || 0;
          this.dialogForm.packageCount = this.dialogForm.packageCount * 1 || 0;
          this.dialogForm.sort = this.dialogForm.sort * 1 || 1;

          if (this.dialogType == "add") {
            // 新建
            this.$API.wtl_addItem(this.dialogForm).then((res) => {
              this.$message.success(res.data.message || "操作成功");
              this.getData();
              this.isShowDialog = false;
            });
          } else {
            // 修改
            this.$API.wtl_udpateItem(this.dialogForm).then((res) => {
              this.$message.success(res.data.message || "操作成功");
              this.getData();
              this.isShowDialog = false;
            });
          }
        }
      });
    },
    //  关闭弹窗按钮事件(关闭按钮)
    diaCancelBtn() {
      this.isShowDialog = false;
    },

    handleCloseDia2() {
      this.isShowDialog2 = false;
    },
    //  弹窗确认保存事件
    diaConfirmBtn2() {
      this.isShowDialog2 = false;
    },
    //  关闭弹窗按钮事件(关闭按钮)
    diaCancelBtn2() {
      this.isShowDialog2 = false;
    },

    /***
     * ====== 弹窗组件方法 ======
     */

    // ===================排序表头彈窗的组件方法 start ===================
    //   取消按钮(表格设置)
    cancelSortHeard() {
      this.show_sortTableHeard = false;
      this.$nextTick(() => {
        this.$refs.mytable.doLayout();
      });
    },
    // 排序==>确认按钮(表格设置)
    confirmOk(e) {
      this.tabelHeadeTitle = e;
      this.myTableHeard = this.tabelHeadeTitle;
      let sortObject = this.myTableHeard;
      let param = {
        groupName: this.pageGroupName, //当前页面表格的标记(自定义字符串)
        sortName: this.sortName, //综合查询接口路径
        sortObject: JSON.stringify(sortObject),
      };
      this.$API.pushFindFieldSort(param).then((res) => {
        this.$message.success(res.data.message || "操作成功");
        //获取默认表头
        this.$TOOLS.getGroupFindFieldSort(this, this.pageGroupName);
      });
      this.show_sortTableHeard = false; //关闭弹窗
      this.$nextTick(() => {
        this.$refs.mytable.doLayout();
      });
      this.show_sortTableHeard = false;
    },
    // 点击某一项(表格设置)
    checktab(idx, e) {
      let that = this;
      that.tabelHeadeTitle[idx].isShow = e;
      let selectLength = 0;
      for (var i = 0; i < that.tabelHeadeTitle.length; i++) {
        if (that.tabelHeadeTitle[i].isShow) {
          selectLength++;
        }
      }
      that.selectLength = selectLength;
      if (selectLength == that.tabelHeadeTitle.length) {
        that.allCheck = true;
      } else {
        that.allCheck = false;
      }
    },
    //全选(表格设置)
    checkAll(e) {
      let that = this;
      this.allCheck = e;
      for (var j = 0; j < this.tabelHeadeTitle.length; j++) {
        this.tabelHeadeTitle[j].isShow = e;
      }
      let selectLength = 0;
      for (var i = 0; i < that.tabelHeadeTitle.length; i++) {
        if (that.tabelHeadeTitle[i].isShow) {
          selectLength++;
        }
      }
      that.selectLength = selectLength;
    },
    //关闭弹窗(表格设置)
    closeDias(e) {
      this.show_sortTableHeard = e;
    },

    /****
     *  ===================排序表头彈窗的组件方法 end ===================
     *
     */
  },
};
</script>

<style scoped lang="less">
// .containerbox {
//   height: calc(100vh - 75px);
// }

// .tableBox {
//   height: calc(100% - 180px);
// }
.colorStyle {
  color: #f00;
}
.mdTitName {
  height: 24px;
  border: 1px solid #d7d7d7;
  text-align: center;
  min-width: 100px;
}
.queryCriteria {
  .queryItem_one {
    .queryTextarea {
      border: 1px solid #d7d7d7;
    }
  }
  .timeBox {
    border: 1px solid #d7d7d7;
  }
}
.headerbox {
  width: 100%;
  display: flex;
  justify-content: center;
}
.imgbox {
  width: 100%;
  margin-left: 12%;
  box-sizing: border-box;
}
.footerbox {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 50px;
}
.newForm {
  margin-left: 80px;
  .queryItem1 {
    width: 60%;
    margin-top: 20px;
  }
}
.singleinp1 {
  min-width: 392px;
}
.HeadInputbox .item_right .singleinp1 .el-date-editor.el-input,
.HeadInputbox .item_right .singleinp1 .el-date-editor.el-input__inner {
  width: 100%;
}
.SingleChoicebox {
  width: 100%;
  padding: 0 20px;
  margin-top: 20px;
  box-sizing: border-box;
}
.el-input-number {
  width: 100%;
  height: 30px;
  line-height: 30px;
}
.serverContent {
  .tableBox {
    background-color: #fff;
  }
  .btnList1 {
    width: auto;
    // padding: 10px;
    border-radius: 4px;
  }
}
</style>
